import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { Collection } from "@/types/collection/collection";
import { RootState } from "@/store";
import { Controllers } from "@infoland/iprova-api";

interface CollectionsState {
    collectionsTree: Collection[];
    loadingPromise: Promise<void>;
}

function initialize(): CollectionsState {
    return {
        collectionsTree: null,
        loadingPromise: null
    };
}

// initial state
const state: CollectionsState = initialize();

// getters for this store
const getters: GetterTree<CollectionsState, RootState> = {
    /**
     * The collections treee
     * @param state The state to read from
     */
    collectionsTree(state: CollectionsState): Collection[] {
        return state.collectionsTree;
    }
};
// mutations for this store
const mutations: MutationTree<CollectionsState> = {
    /* Set the collections tree
     * @param state The state to write to
     * @param  last received collections tree
     */
    _collectionsTree(state: CollectionsState, collectionsTree: []) {
        state.collectionsTree = collectionsTree;
    },

    loadingPromise(state: CollectionsState, promise: Promise<void>) {
        if (promise !== null && state.loadingPromise !== null) {
            throw new Error("already a load promise");
        }
        state.loadingPromise = promise;
    }
};

// actions for this store
const actions: ActionTree<CollectionsState, RootState> = {
    loadTree({ commit, state }: ActionContext<CollectionsState, RootState>): Promise<void> {
        if (state.loadingPromise) {
            //return the existing load promise
            return state.loadingPromise;
        } else if (state.collectionsTree) {
            //already done
            return Promise.resolve();
        } else {
            //create new promise to load collections
            return new Promise(resolve => {
                const loadingPromise = Controllers.GenericController.getAsync<Collection[]>(
                    "portals/collections/roots/?include_sub_tree=true&has_content_items=true"
                );

                //put the promise in the state so the same promise can be returned to a next caller
                commit("loadingPromise", loadingPromise);

                //when load is complete, commit the tree to the stae
                loadingPromise.then(collections => {
                    commit("_collectionsTree", collections);

                    //remove the current promise from the state
                    commit("loadingPromise", null);

                    //resolve the made promise to load collection
                    resolve();
                });
            });
        }
    }
};

// export the namespace
export const namespace: string = "collections";

// export the store 'module'
export default <Module<CollectionsState, RootState>>{
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
